/**
 * @desc undefined
 */
import {
  SendCodeResult,
  SendCodeToCurrentUserOption
} from '@eastcoal/api/nexus/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type SendSmsCodeToCurrentUserParameter = SendCodeToCurrentUserOption

const method = 'POST'
const url = '/nexus/sms/code/sendToCurrentUser'

export const sendSmsCodeToCurrentUserApi = (
  data?: SendSmsCodeToCurrentUserParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<SendCodeResult>({
    method,
    url,
    data,
    ...config
  })
}

sendSmsCodeToCurrentUserApi.method = method
sendSmsCodeToCurrentUserApi.url = url
